import { asField, Option } from "informed";
import React, { Fragment } from "react";
import Select from "react-select";

export const AutocompleteValue = asField(({ fieldState, fieldApi, ...props }) => {
  const { value, label } = fieldState;

  const { setTouched } = fieldApi;
  const { field, onChange, onBlur, initialValue, forwardedRef, excludeEmptyOption, emptyValue, emptyLabel, option, options, selectedOption, getOptionValue, getOptionLabel, radioInline, onClick, ...rest } = props;
  return (
    <Fragment>
      {props.label && <label htmlFor={options}>{props.label}</label>}
      {/* <div style={{ zIndex: 999 }}> */}
      <Select
        {...rest}
        required
        id={field}
        field={field}
        options={options}
        value={value}
        getOptionLabel={getOptionLabel}
        onChange={(e) => {
          if (onChange) {
            onChange(e, value);
          }
        }}
        onClick={props.onClick}
        onBlur={(e) => {
          setTouched();
          if (onBlur) {
            onBlur(e);
          }
        }}
        styles={{ zIndex: "20000000", background: "white" }}
      >
        {!excludeEmptyOption && (
          <Option value={emptyValue ? emptyValue : ""} className="custom-control-input">
            {emptyLabel ? emptyLabel : "Select the option"}
          </Option>
        )}
        {options &&
          options.map((option, i) => (
            <Option
              style={{
                width: "50px !important",
                color: "black!important",
              }}
              value={getOptionValue ? getOptionValue(option) : option.value ? option.value : option}
              id={`${field}-${i}`}
              className="custom-control-input"
              key={i}
            >
              {i.getOptionLabel ? getOptionLabel(option) : option.label ? option.label : option}
            </Option>
          ))}
      </Select>
      {/* </div> */}
      {fieldState.error ? <div className="invalid-field">{fieldState.error}</div> : null}
    </Fragment>
  );
});

// const options = [
//     { value: '', label: '' },
//     { value: '', label: '' },
//  //   { value:{field} , label: {field} },
//   ];
